import React, { useCallback, useState, useEffect } from 'react';
import { hooks } from 'botframework-webchat-component';
import AbilityIcon from '../../images/Ability.svg';
import useFavorites from '../../hooks/useFavorites';


const { useSendEvent, useSendMessage } = hooks;

const Offers = ({ offers, isArabic, locked = false }) => {
  let contractAccNumber = offers.requestParams.ContractAccNumber;
  if (!contractAccNumber) {
    contractAccNumber = offers.requestParams.contractAccNumber;
  }

  // Use the shared favorites hook
  const { isFavorite, toggleFavorite } = useFavorites(contractAccNumber);

  console.log('Toggled favorite for offer:', contractAccNumber);

  if (offers.offers[0]?.OfferNameAr){
    isArabic = true;

  }else{
    isArabic = false;
  }
  console.log('Offers component isArabic:', isArabic);
  console.log('Offers component received:', offers);
  // Import the sendEvent and sendMessage hooks
  const sendEvent = useSendEvent();
  const sendMessage = useSendMessage();
  // Add state to track if "View more" was clicked
  const [viewMoreClicked, setViewMoreClicked] = useState(false);
  // Add state to track if we're on mobile
  const [isMobile, setIsMobile] = useState(false);

  // At runtime (deployed), values come from window.contextvars which is served dynamically
  // by the Python backend from Azure App Service environment variables.
  // Locally, fall back to process.env (CRA injects .env values at build time).
  function getRuntimeEnv(key) {
    return (
      (typeof window !== 'undefined' && window.contextvars && window.contextvars[key]) ||
      process.env[key] ||
      ''
    );
  }

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  if (!offers) {
    return null;
  }
  
  // Extract the actual offers array from the nested structure
  let offersArray = [];
  
  if (offers.offers && Array.isArray(offers.offers)) {
    console.log('Found nested offers array with length:', offers.offers.length);
    offersArray = offers.offers;
  } else if (Array.isArray(offers)) {
    console.log('Offers is already an array with length:', offers.length);
    offersArray = offers;
  }
  
  if (offersArray.length === 0) {
    return null;
  }

  // Get the selected category title if available
  const categoryTitle = offers.selectedCategory || '';

  // Function to handle view offer request
  const handleViewOffer = (offer) => {
    // Send the event using the sendEvent hook with the entire offer object
    offer['contractAccNumber'] = contractAccNumber;
    sendEvent("requestOffer", offer);
    console.log('Requested offer details for offer:', offer);
    // Disable user interactions through the parent component
    sendEvent("disableInteractions", { reason: "requestOffer" });
  };

  // Function to handle redeem offer
  const handleRedeemOffer = (offer) => {
    // Send redeem offer event instead of redirecting
    const redeemEventData = {
      offerUno: offer.OfferUno,
      language: isArabic ? 'ar' : 'en',
      offerName: offer.OfferName,
    };
    
    // Disable user interactions through the parent component
    sendEvent("disableInteractions", { reason: "redeemOffer" });
    
    // Send the redeem offer event
    sendEvent("redeemOffer", redeemEventData);
  };

  // Determine if there are more offers to load
  const hasMoreOffers = () => {

    if(offers.moreoffersavailable == true)
      return true


    if (!offers.requestParams) return false;
    console.log('Checking for more offers with requestParams:', offers.offers[0].totalcount);



    const totalCount = offers.offers[0].totalcount || 0;
    const pageSize = offers.requestParams.PageSize || 5;
    const pageNumber = offers.requestParams.PageNumber || 1;
    
    // if in the page there are more offers ie when divided less then 6 don't show
    if (pageSize * pageNumber <totalCount ) {
      return true;
    }
    return false;

    // If we received a full page of offers, likely there are more
  };

  // Handle view more offers button click
  const handleViewMoreOffers = () => {
    console.log('Requesting more offers');
    // Set clicked state to true to remove the button
    setViewMoreClicked(true);
    
    // Disable user interactions through the parent component (like other actions)
    sendEvent("disableInteractions", { reason: "viewMoreOffers" });
    
    // Send a message to request more offers instead of an event
    const viewMoreMessage = isArabic ? "عرض المزيد من العروض" : "View more offers";
    sendMessage(viewMoreMessage);
    console.log('Sent view more message:', viewMoreMessage);
  };

  // Handle favorite toggle
  const handleFavoriteToggle = (offer) => {
    const offerUno = offer.OfferUno;
    
    // Get initial server favorite state
    const initialServerFavoriteValue = offer.is_favourite === true || offer.IsFavourite === true;
    
    console.log('Toggling favorite for offer:', offerUno, 'Server value:', initialServerFavoriteValue);
    
    // Toggle favorite using the shared hook (this will check server data first, then user changes)
    const newFavoriteState = toggleFavorite(offerUno, initialServerFavoriteValue);
    
    console.log('New favorite state:', newFavoriteState);
    
    // Disable user interactions through the parent component
    sendEvent("disableInteractions", { reason: "favoriteToggle" });
    
    // Send appropriate event based on new state
    if (newFavoriteState) {
      sendEvent("addToFavorite", { offerUno, contractAccNumber });
      console.log('Added to favorites:', offerUno);
    } else {
      console.log('Removing from favorites:', contractAccNumber);
      sendEvent("removeFromFavourite", { offerUno, contractAccNumber });
      console.log('Removed from favorites:', offerUno);
    }
  };

  return (
    <div className="mt-5 w-full"> {/* Changed from mt-2 to mt-4 for more margin */}
      {/* Grid container with equal width columns */}
      <div 
        style={{ 
          width: '100%',
          display: offersArray.length >= 3 && !isMobile
            ? 'grid' 
            : 'flex',
          ...(offersArray.length >= 3 && !isMobile
            ? {
                gridTemplateColumns: 'repeat(3, 1fr)',
              }
            : {
                justifyContent: 'flex-start',
                gap: '16px',
                ...(isMobile && {
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  maxWidth: '90%', // Decreased width on mobile
                  margin: '0 auto' // Center the container
                })
              }
          ),
          gap: '16px',
          margin: 0,
          padding: 0,
        }}
      >
        {offersArray.map((offer, index) => {
          // Extract offer properties with fallbacks
          const companyName = offer.CompanyName || offer.companyName || '';
          const logoUrl =  getRuntimeEnv('REACT_APP_DEWA_STORE_LOGO_BASE_URL') + offer.ThumbnailUrl;
          const offerName = offer.OfferName || offer.offerName || offer.OfferNameAr || '';
          const discountPercentage = offer.DiscountPercentage || offer.discountPercentage || 0;

          let location = '';
          if (offer.Address) {
            location = offer.Address ? offer.Address.split(',')[3]?.trim() || '' : '';
          }else{
            location = offer.AddressAr ? offer.AddressAr.split(',')[3]?.trim() || '' : '';

          }

          // Get currency code with fallback
          
          // Format display price 
            
          // Format actual price if available
          
          // Determine if this offer should show as favorite - use server data + user changes
          const offerUno = offer.OfferUno;
          const initialServerFavoriteValue = offer.is_favourite === true || offer.IsFavourite === true;
          const shouldShowAsFavorite = isFavorite(offerUno, initialServerFavoriteValue);
          
          // Check if favorite functionality should be available for this offer
          const hasFavoriteData = offer.is_favourite !== undefined || offer.IsFavourite !== undefined;
          
          console.log(`Offer ${offerUno}:`, {
            serverValue: initialServerFavoriteValue,
            shouldShow: shouldShowAsFavorite,
            hasFavoriteData,
            rawServerData: { is_favourite: offer.is_favourite, IsFavourite: offer.IsFavourite }
          });
          
          return (
            <div 
              key={index} 
              className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
              style={{ 
                width: isMobile ? '100%' : (offersArray.length >= 3 ? '100%' : '32%'),
                height: isMobile ? 'auto' : '10vh',
                minHeight: isMobile ? '240px' : '240px',
                position: 'relative', 
                display: 'flex', 
                flexDirection: 'column',
                ...(isMobile && {
                  maxWidth: '100%', // Ensure cards don't exceed container width
                })
              }}
            >
              {/* Featured/Hot/New badges */}
              {offer.IsPODOffer === 1 && (
                <div 
                  className={`absolute top-4 ${hasFavoriteData ? (isArabic ? 'left-12' : 'right-12') : (isArabic ? 'left-4' : 'right-4')} text-xs px-2 py-1 flex items-center`}
                  style={{
                    backgroundColor: '#e0eeec', // bg-green-100 equivalent
                    color: '#097767', // text-green-800 equivalent
                    fontWeight: '600', // Increased font weight (semibold)
                    borderRadius: '8px' // Control roundedness (changed from rounded-full)
                  }}
                >
                  {isArabic ? (
                    <>
                      <span>إضافي</span>
                      <img src={AbilityIcon} alt="Ability" style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                    </>
                  ) : (
                    <>
                      <img src={AbilityIcon} alt="Ability" style={{ width: '16px', height: '16px', marginRight: '4px' }} />
                      <span>Extra</span>
                    </>
                  )}
                </div>
              )}
              
              {/* Favorite Star Icon - only show if favorite data is available */}
              {hasFavoriteData && (
                <div 
                  className={`absolute top-4 ${isArabic ? 'left-4' : 'right-4'} ${locked ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!locked) {
                      handleFavoriteToggle(offer);
                    }
                  }}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill={shouldShowAsFavorite ? "#FFD700" : "none"}
                    stroke={shouldShowAsFavorite ? "#FFD700" : "#6b7280"} 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    className="transition-colors duration-200"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                </div>
              )}
              
              {/* Card content area */}
              <div className="p-4 flex-none overflow-hidden">
                {/* Logo */}
                <div className="mb-4 h-20 flex items-center justify-start">
                  <div 
                    style={{
                      boxShadow: '0px 2px 4px rgba(0,0,0,0.15)',
                      padding: '12px',
                      borderRadius: '5px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      width: '80px',  // Fixed width for container
                      height: '80px', // Fixed height for container
                    }}
                  >
                    <img 
                      src={logoUrl || 'https://via.placeholder.com/60?text=Logo'} 
                      style={{ 
                        maxHeight: '60px', 
                        maxWidth: '60px',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                </div>
                
                {/* Location */}
                <div className="text-gray-500 text-sm mb-1">
                  {location || offer.CompanyType || ""}
                </div>
                
                {/* Package title */}
                <h3 className="text-base font-medium line-clamp-1">
                  {offerName}
                </h3>
              </div>
              
              {/* Button container - responsive layout */}
              <div className="px-4" style={{ paddingBottom: '16px' }}>
                <div 
                  className="flex"
                  style={{
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '8px' : '8px',
                    ...(isMobile && {
                      paddingLeft: '8px',
                      paddingRight: '8px'
                    })
                  }}
                >
                  <button 
                    className={`${isMobile ? 'w-full' : 'flex-1'} px-3 py-3 rounded-full ${locked ? 'opacity-50' : ''} transition-colors text-sm font-medium`}
                    onClick={() => !locked && handleViewOffer(offer)}
                    style={{ 
                      borderRadius: '999px',
                      border: '1px solid #027560',
                      color: '#027560',
                      backgroundColor: locked ? undefined : 'transparent',
                      ...(isMobile && {
                        fontSize: '14px',
                        padding: '12px 16px'
                      })
                    }}
                    onMouseEnter={(e) => {
                      if (!locked) {
                        e.target.style.backgroundColor = '#f0fdfa';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!locked) {
                        e.target.style.backgroundColor = 'transparent';
                      }
                    }}
                    disabled={locked}
                  >
                    {isArabic ? "عرض التفاصيل" : "View Details"}
                  </button>
                  <button 
                    className={`${isMobile ? 'w-full' : 'flex-1'} text-white px-3 py-3 rounded-full text-sm font-medium`}
                    onClick={() => !locked && handleRedeemOffer(offer)}
                    style={{ 
                      borderRadius: '999px',
                      backgroundColor: '#027560', 
                      ...(isMobile && {
                        fontSize: '14px',
                        padding: '12px 16px',
                      })
                    }}
                    disabled={locked}
                  >
                    {isArabic ? "استرداد العرض" : "Redeem Offer"}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Style to force parent container to be full width */}
      <style jsx global>{`
        .webchat__bubble__content {
          width: 100% !important;
          max-width: 100% !important;
        }
        
        .webchat__bubble__content > div {
          width: 100% !important;
          max-width: 100% !important;
        }
      `}</style>
      
      {/* View More button - only show if there are more offers and hasn't been clicked */}
      {hasMoreOffers() && !viewMoreClicked && !locked && (
        <div 
          className="mt-2" 
          style={{ 
            textAlign: isArabic ? 'right' : 'left'
          }}
        >
          <a
            className={`text-emerald-700 cursor-pointer ${locked ? 'opacity-50' : ''}`}
            onClick={() => !locked && handleViewMoreOffers()}
            style={{
              textDecoration: 'none',
              transition: 'font-weight 0.2s ease',
              fontSize: '16px',
              display: 'inline-block',
              pointerEvents: locked ? 'none' : 'auto'
            }}
            onMouseEnter={(e) => !locked && (e.target.style.fontWeight = 'bold')}
            onMouseLeave={(e) => !locked && (e.target.style.fontWeight = 'normal')}
          >
            {isArabic ? "عرض المزيد" : "View more"}
          </a>
        </div>
      )}
    </div>
  );
};

export default Offers;